import LandingComposer from './LandingComposer';
import { FINAL_CTA_COPY } from './landingContent';
import { useLandingReveal, usePrefersReducedMotion } from './useLandingReveal';

function FinalComposerCta({ composerProps }) {
  const reducedMotion = usePrefersReducedMotion();
  const [revealRef, revealed] = useLandingReveal();
  const visible = revealed || reducedMotion;

  return (
    <section className="lp-section lp-final-cta" aria-labelledby="lp-final-heading">
      <div className="lp-container">
        <div ref={revealRef} className={`lp-reveal${visible ? ' lp-reveal--visible' : ''}`}>
          <h2 id="lp-final-heading" className="lp-heading">
            {FINAL_CTA_COPY.heading}
          </h2>
          <p className="lp-body">{FINAL_CTA_COPY.body}</p>
          <div className="lp-final-cta__composer">
            <LandingComposer
              {...composerProps}
              location="final"
              placeholder={FINAL_CTA_COPY.placeholder}
              riskReversal={FINAL_CTA_COPY.riskReversal}
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default FinalComposerCta;
